import { DirectionalHint } from "@fluentui/react";
import React, { FunctionComponent } from "react";
import { CoachmarkInfo } from "../CoachmarkInfo";
import { PFCoachmark } from "../PFCoachmark";
import { CoachmarkLocaleItem } from "../../Locales/Coachmarks/Locale_CoachmarkItem";
import { useTranslation } from "../../Locales/i18n/localizationService";

export const ProjectCapacityCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const projectGroupText = new CoachmarkLocaleItem(t("Coachmarks.ProjectCapacity.GroupBy.Headline"), t("Coachmarks.ProjectCapacity.GroupBy.Text"));
	const _projectGroupBy = new CoachmarkInfo("project-capacity-group-by", ".tp-capacity-project-menucontainer", projectGroupText, DirectionalHint.bottomCenter)

	return	<>
				<PFCoachmark CoachmarkInfo={_projectGroupBy} />
			</>
})



export const ResourceCapacityCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const requestWorkPackagesText = new CoachmarkLocaleItem(t("Coachmarks.ProjectCapacity.RequestWorkPackages.Headline"), t("Coachmarks.ProjectCapacity.RequestWorkPackages.Text"));
	const _requestWorkPackages = new CoachmarkInfo("project-capacity-work-packages", ".tp-capacity-project-menucontainer", requestWorkPackagesText, DirectionalHint.rightCenter);

	return	<>
				<PFCoachmark CoachmarkInfo={_requestWorkPackages} />
			</>
})